import { takeLatest, put, call } from "redux-saga/effects";
import ACTIONS from "./DashboardActionTypes";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import { axiosGet } from "../../Utils/axios";
import {
  getDashboardCardResponse,
  getDashboardLineChartMonthlyResponse,
  getDashboardLineChartYearlyResponse,
  getDashboardPieCreatedByResponse,
  getDashboardPieEmployeeResponse,
  getDashboardPieGroupByPurposeResponse,
  getDashboardPieStatusResponse,
} from "./DashboardActions";

export function* onGetDashboardCardHelperSaga() {
  try {
    const response = yield call(() =>
      axiosGet("dashboard/card").then((res) => res?.data)
    );
    yield put(getDashboardCardResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardPieEmployeeHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/pie/employee?mode=${mode}`).then((res) => res?.data)
    );
    yield put(getDashboardPieEmployeeResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardPieStatusHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/pie/visitor_status?mode=${mode}`).then(
        (res) => res?.data
      )
    );
    yield put(getDashboardPieStatusResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardPiePurposeOfVisitHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/pie/purpose_of_visit?mode=${mode}`).then(
        (res) => res?.data
      )
    );
    yield put(getDashboardPieGroupByPurposeResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardPieCreatedByHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/pie/created_by?mode=${mode}`).then((res) => res?.data)
    );
    yield put(getDashboardPieCreatedByResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardLineMonthlyHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/line/monthly?mode=${mode}`).then((res) => res?.data)
    );
    yield put(getDashboardLineChartMonthlyResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetDashboardLineYearlyHelperSaga({ payload }) {
  try {
    const { mode } = payload;
    const response = yield call(() =>
      axiosGet(`dashboard/line/yearly?mode=${mode}`).then((res) => res?.data)
    );
    yield put(getDashboardLineChartYearlyResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* DashboardWatcherSaga() {
  //CARD
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_CARD_REQUEST,
    onGetDashboardCardHelperSaga
  );
  //PIE
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_PIE_EMPLOYEE_REQUEST,
    onGetDashboardPieEmployeeHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_PIE_STATUS_REQUEST,
    onGetDashboardPieStatusHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_REQUEST,
    onGetDashboardPiePurposeOfVisitHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_PIE_CREATED_BY_REQUEST,
    onGetDashboardPieCreatedByHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_LINE_CHART_MONTHLY_REQUEST,
    onGetDashboardLineMonthlyHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_DASHBOARD_LINE_CHART_YEARLY_REQUEST,
    onGetDashboardLineYearlyHelperSaga
  );
}
